import { LegacyStack, Modal, ResourceItem, ResourceList, Text } from '@shopify/polaris'

import { AdaptiveModal } from '../common/AdaptiveModal'
import { CenteredSpinner, DialogActivator, nl2br } from '../common/helpers'
import { useCustomerAddressesSWR } from './api'
import { CustomerAddress } from './models'

export const AddressesModal = ({
  activator,
  customerGid,
  onComplete,
}: {
  activator: DialogActivator
  customerGid: string
  onComplete: (address?: CustomerAddress) => void
}) => {
  const { data: addresses } = useCustomerAddressesSWR(customerGid, activator.open)

  return (
    <AdaptiveModal
      open={activator.open}
      onClose={activator.close}
      title="Saved addresses"
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: () => onComplete(undefined),
        },
      ]}
    >
      {!addresses && (
        <Modal.Section>
          <CenteredSpinner />
        </Modal.Section>
      )}
      {addresses && (
        <ResourceList
          emptyState={
            <LegacyStack distribution="center">
              <p style={{ padding: '2rem' }}>No addresses found</p>
            </LegacyStack>
          }
          items={addresses?.map((address) => ({
            id: address.id,
            content: address.formatted,
          }))}
          renderItem={(item) => {
            return (
              <ResourceItem
                id={item.id}
                onClick={() => {
                  onComplete(addresses?.find((address) => address.id === item.id))
                }}
              >
                <Text as="p">{nl2br(item.content)}</Text>
              </ResourceItem>
            )
          }}
        />
      )}
    </AdaptiveModal>
  )
}
